<template>
  <div class="foldersContainer">
      <div v-if="confirmationMessage" class="alert alert-success" role="alert">
        {{ confirmationMessage }}
      </div>
      <h2>Espace perso de {{ userName }}</h2>
        <div class="sectForm">
          <nested-list :dossiers="dossiers" @ajouter-element="ajouterNewElement" @ajouter-fichiers="ajouterNewFichiers" @selection-change="handleSelectionChange"></nested-list>
         
          <div class="deleteRow">
            <button @click="supprimerElements()" class="delete-button">Supprimer les éléments sélectionnés</button>
          </div>
          
        </div>
  </div>


   <!-- Loader -->
   <div v-if="isLoading" class="loader">
    <div id="loading"></div>
  </div>
</template>

<script>
import axios from '@/components/axiosConfig.js';

import NestedList from './DossiersList.vue'; // Assurez-vous d'ajuster le chemin d'accès au fichier NestedList.vue



export default {
  name: 'MainComponent',
  components: {
    NestedList
  },
  data() {
    return {
      dossiers:[],
      userName:'',
      isLoading: false,
      isExpanded: false,
      popupOpen: false,
      typeDoc: 'dossier',
      nomFichier:'',
      fichiers: [],
      selectedDocuments: [],
      url:'',
      confirmationMessage: '',
      selectedItems: []  // Déplacez cette propriété ici

    }
  },
  created() {
    this.userName = this.$route.params.nom + ' ' + this.$route.params.prenom;
  },
  mounted() {
     
      this.getFoldersUtilisateur()

      
      
  },
  methods: {
      handleSelectionChange(dossier) {
        console.log('handled');
        const index = this.selectedItems.indexOf(dossier);

        if (index === -1) {
          this.selectedItems.push(dossier);
        } else {
          this.selectedItems.splice(index, 1);
        }

        console.log('Contenu du tableau selectedItems :', this.selectedItems);
      },
      getFoldersUtilisateur() {
        this.isLoading = true; // Show loader
        axios.post('https://www.simef.fr/espace-client/api/getFoldersUtilisateur.php', {
            name: this.userName
          })
          .then(response => {
              this.dossiers = response.data;
          })
          .catch(error => {
              console.error(error);
              
          })
          .finally(() => {
            this.isLoading = false; // Hide loader
          });
      },
      toggleDossier(dossier) {
      dossier.isExpanded = !dossier.isExpanded;
    },
    addFichiers(event) {
      const files = event.target.files;
      for (let i = 0; i < files.length; i++) {
          this.fichiers.push(files[i]);
      }
    },
    openPopup(url) {
      this.popupOpen = true;
      this.url = url;
    },

    closePopup(event) {
      event.stopPropagation();
      this.popupOpen = false;
    },
    ajouterElement() {
      this.isLoading = true; // Show loader
      // Create a new FormData object
      const formData = new FormData();

      // Ajouter les fichiers au formulaire
      for (let i = 0; i < this.fichiers.length; i++) {
          formData.append('fichiers[]', this.fichiers[i]);
      }
      // Add the user and chantier information to the form data
      formData.append('chemin', this.url);
      formData.append('typeDoc', this.typeDoc);
      formData.append('nomFichier', this.nomFichier);
      console.log(this.fichiers);

      // Make the API request
      axios.post('https://www.simef.fr/espace-client/api/addElementEspace.php', formData)
      .then(response => {
          // Handle the response from the server
          console.log(response);
          if (response.data.success) {
            let nouveauElement = {
              nom: this.nomFichier,
              type: this.typeDoc,
              chemin: this.url + '/' + this.nomFichier,
              sousDossiers: []
              // Ajoutez d'autres attributs nécessaires pour votre objet élément ici
            };
            let cheminDuDossierAModifier = this.url;
            
            this.$emit('ajouter-element', nouveauElement, cheminDuDossierAModifier);


          }
          
          this.confirmationMessage = response.data.success;
          this.errorMessage = response.data.error;
          this.fichiers = [];
          this.nomFichier = '';

      
      })
      .catch(error => {
          console.error(error);
          this.refusMessage = "Une erreur est survenue";
      })
      .finally(() => {
        this.isLoading = false; // Hide loader
      });
    },
    ajouterNewElement(nouveauElement, cheminDuDossierAModifier) {
      console.log('ajouterNewElement est appelé');
      // Chercher l'index du dossier à modifier dans le tableau
      const index = this.dossiers.findIndex(dossier => dossier.chemin == cheminDuDossierAModifier);

      // Si le dossier a été trouvé
      if (index !== -1) {
        // Vérifier si le nouvel élément est un sous-dossier
        if (nouveauElement.type === 'dossier') {
          // Ajouter le nouvel élément au tableau sousDossiers du dossier parent
          this.dossiers[index].sousDossiers.push(nouveauElement);
        } else {
          // Ajouter le nouvel élément directement au tableau dossiers
          this.dossiers.push(nouveauElement);
        }
      }
  
    },
    ajouterNewFichiers(nouveauxFichiers, cheminDuDossierAModifier) {
      console.log('ajouterNewFichiers est appelé');
      // Chercher l'index du dossier à modifier dans le tableau
      const index = this.dossiers.findIndex(dossier => dossier.chemin == cheminDuDossierAModifier);

      // Si le dossier a été trouvé
      if (index !== -1) {
        // Vérifier si le nouvel élément est un sous-dossier
        
          // Ajouter le nouvel élément au tableau sousDossiers du dossier parent
          for (let i = 0; i < nouveauxFichiers.length; i++) {
            if (nouveauxFichiers[i].type === 'fichier') {
              this.dossiers[index].sousDossiers.push(nouveauxFichiers[i]);
            } else {
              this.dossiers.push(nouveauxFichiers[i]);
            }
          }
        
      }
  
    },
    telechargerFichier(url, nomFichier) {
      const motARemplacer = '/simef';
      const urlModifiee = url.replace(motARemplacer, 'https://www.simef.fr');

      fetch(urlModifiee)
        .then(response => response.blob())
        .then(blob => {
          const urlBlob = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = urlBlob;
          a.download = nomFichier;
          a.click();
          window.URL.revokeObjectURL(urlBlob);
        })
        .catch(error => {
          console.error(error);
        });
    },
    supprimerElements() {
    if (this.selectedItems.length === 0) {
      // Si aucun élément n'est sélectionné, affichez un message d'erreur ou alerte.
      return;
    }

    const confirmation = window.confirm("Êtes-vous sûr de vouloir supprimer les éléments sélectionnés ?");
    if (confirmation) {
      axios.post('https://www.simef.fr/espace-client/api/removeElementEspace.php', {
        selectedItems: this.selectedItems,
        utilisateur: this.userName,
      })
      .then(response => {
        if (response.data.success) {
          // Si la suppression réussit, mettez à jour le tableau des dossiers
          this.selectedItems.forEach(item => {
            this.removeItem(this.dossiers, item);
          });

          // Effacer les éléments sélectionnés après la suppression réussie
          this.selectedItems = [];
        }
        this.confirmationMessage = response.data.success;
      })
      .catch(error => {
        console.error(error);
      });
    }
  },
    
    removeItem(items, itemToRemove) {
      const index = items.findIndex(item => item === itemToRemove);
      if (index !== -1) {
        items.splice(index, 1);
      } else {
        for (const item of items) {
          if (item.sousDossiers.length > 0) {
            this.removeItem(item.sousDossiers, itemToRemove);
          }
        }
      }
    },
  
    
  }
}
</script>

<style lang="scss">
.foldersContainer {
    background: #f2f2f2;
    padding: 35px!important;
    border: 0px;
}
.sub {
  list-style: none;
}
.checkDossiers {
  list-style: none;
  padding: 0;
}
.subfolders {
    display: flex;
    flex-direction: row;
    align-items: center;

    input {
      width: inherit!important;
      margin-bottom: 0px!important;
    }

}

.check {
  display: flex;
  align-items: center;

  input[type="checkbox"] {
    width: inherit!important;
  }
}
.error-message {
  font-size: 0.8rem;
  text-align: left;
}

.deleteRow {
  text-align: left;
}
  
</style>